import styled, { css } from 'styled-components';

export const IconSnappyProductOffer = styled.img`
  ${({ theme }) => css`
    border-radius: 100%;
    box-shadow: 0 0 0 13px rgba(252, 252, 252, 0.40), 0 0 50px 13px rgba(46, 147, 238, 0.20);
    height: 94px;
    width: 94px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      display: none;
    }
  `}
`;

export const HeaderProductOffer = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 24px;
    
    @media (min-width: ${theme.v3.breakpoints.md}) {
      text-align: center;
    }
  `}
`;

export const BgProductOffer = styled.div`
  background: rgba(160, 201, 255, 0.50);
  border-radius: 100%;
  bottom: -675px;
  filter: blur(220px);
  height: 801px;
  left: 50%;
  pointer-events: none;
  position: absolute;
  width: 827px;
  transform: translateX(-50%);
`;
